import { createStyles, makeStyles, Theme, Container } from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { TitleBackBar } from '../../../shared/header/TitleBar';
import { basic, product as v_product } from '../../../request/values';

const SERVER = basic.server;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		pdfContainer: {
			// overflowX: 'auto',
			// overflowY: 'auto',
			overflow: 'auto',
			width: '100%',
			marginTop: '1.5vh',
			// marginLeft: '-8vw',
		},
		pdfPage: {
			// width: '200px',
		},
		titleFont: {
			fontSize: '3.6vw',
		},
	}),
);

const LicenseManual: React.FC<any> = (props) => {
	const { t } = useTranslation('student');
	const classes = useStyles();
	const width = getWidth(window?.innerWidth);
	const [numPage, setNumPage] = useState<number | null>(null);
	const history = useHistory();

	const state: any = history.location.state;
	const productMenualFile = state.productMenualFile;

	const fileSource = useMemo(() => ({ url: SERVER + v_product.display_file + productMenualFile }), [productMenualFile]);

	const onDocumentLoadSuccess = (document: any) => {
		console.log('load success', document);
		const parentDiv = document;
		setNumPage(document.numPages);
	};
	function getWidth(innerWidth: number) {
		if (innerWidth) {
			if (innerWidth < 748) {
				return innerWidth;
			} else if (innerWidth >= 748) {
				if (innerWidth - 290 > 1024) {
					return 1024;
				} else return innerWidth - 290;
			}
		}
	}
	return (
		<Container maxWidth={false} disableGutters={true}>
			<TitleBackBar history={history} title={t('LicenseManual.title')} titleIcon="license" />
			<div className={classes.pdfContainer}>
				<Document
					file={fileSource}
					onLoadSuccess={onDocumentLoadSuccess}
					onLoadError={(error) => console.log('Error while loading document! ' + error.message)}
					loading={''}
					data-testid="manu-product-manual-pdf"
				>
					{Array.from(new Array(numPage), (el, index) => (
						<Page width={width} className={classes.pdfPage} key={`page_${index + 1}`} pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} />
					))}
				</Document>
			</div>
		</Container>
	);
};

export default LicenseManual;
